import { Grid } from "@material-ui/core"
import classNames from "classnames"
import { useDefaultCadastroStyles } from "views/pages/private/cadastros/components/default-cadastro-styles";
import { useStyles } from "./historico-atualizacoes-list-styles";
import { memo, useCallback, useEffect, useState } from "react";
import { HistoricoAtualizacoesListData } from "./historico-atualizacoes-list-data";
import { useGetLog } from "data/api/gestao/clickup/get-log";
import { useToastSaurus } from "services/app";
import { LogModel } from "model/api/gestao/clickup/log-model";
import { EnumSistemasHistorico } from "data/mocks/sistemas-roadmap-mock";

export interface HistoricoAtualizacoesListProps {
    sistemaSelected: string
    historicoFiltro: "data" | "versao"
    setIsCarregandoInterno: (carregando: boolean) => void
    carregando: boolean
}

const sistemaSelecionado = (sistema: string) => {
    const sistemasEnum: Record<string, number> = {
        [EnumSistemasHistorico.PDVApp]: 21,
        [EnumSistemasHistorico.PDVMobile]: 60,
        [EnumSistemasHistorico.S2PayMobile]: 61,
        [EnumSistemasHistorico.Transmissor]: 5,
        [EnumSistemasHistorico.RetaguardaApp]: 4,
        [EnumSistemasHistorico.TerminalPreVendaWindows]: 12,
        [EnumSistemasHistorico.ImpressorLocalV4]: 22,
        [EnumSistemasHistorico.TouchOne]: 72,
        [EnumSistemasHistorico.TouchoneRetaguarda]: 71,
        [EnumSistemasHistorico.TouchonePDV]: 70,
        [EnumSistemasHistorico.CardapioTouchOne]: 73,
        [EnumSistemasHistorico.ImpressorTouchOne]: 74,
        [EnumSistemasHistorico.Cartorio]: 75,
        [EnumSistemasHistorico.Comandas]: 63,
        [EnumSistemasHistorico.PedApi]: 23,
        [EnumSistemasHistorico.PedidosMobile]: 62,
    }

    return sistemasEnum[sistema]
}

export const HistoricoAtualizacoesList = memo(({ sistemaSelected, historicoFiltro, setIsCarregandoInterno, carregando }: HistoricoAtualizacoesListProps) => {
    const { getLog } = useGetLog()
    const cadastroClasses = useDefaultCadastroStyles();
    const { showToast } = useToastSaurus()
    const classes = useStyles()
    const [log, setLog] = useState<LogModel>(new LogModel())

    const handleGetLog = useCallback(async () => {
        try {
            if (!sistemaSelected) return
            setIsCarregandoInterno(true)
            const res = await getLog(sistemaSelecionado(sistemaSelected))
            if (res.erro) throw res.erro

            const resultado = res.resultado?.data as LogModel
            setLog(resultado)
        } catch (err: any) {
            showToast('error', err.message)
        } finally {
            setIsCarregandoInterno(false)
        }
    }, [getLog, setIsCarregandoInterno, showToast, sistemaSelected])

    useEffect(() => {
        handleGetLog()
    }, [handleGetLog])

    return (
        <>
            <Grid item xs={12} sm={12} md={12} className={classNames(classes.list, cadastroClasses.list)}>
                <Grid className={classes.defaultContainer}>
                    <HistoricoAtualizacoesListData log={log} backlogFiltro={historicoFiltro} carregando={carregando} sistemaSelected={sistemaSelected} />
                </Grid>
            </Grid>
        </>
    )
})